module.exports = __webpack_public_path__ + "img/restaurant-1.f757b92e.png";